// How to play: five short steps with real tiles, from the Today screen or the ? in the game, and
// by itself when a first game opens.
import type { EditionInfo } from '@wbwl/contract'
import { RULES_VERSION, SAMPLE_EDITION, ranksFor } from '@wbwl/rules'
import { Ladder, WordTiles } from './game-ui.tsx'
import { Icon } from './Icon.tsx'
import { Sheet } from './shell.tsx'

// The design boards' sample edition, scored under today's rules.
const SAMPLE = { ...SAMPLE_EDITION, rulesVersion: RULES_VERSION }
const SAMPLE_RANKS = ranksFor(1088)

export function HowTo({ open, onClose, onPlay }: { open: boolean; onClose(): void; onPlay?(): void; edition?: EditionInfo }) {
  return (
    <Sheet open={open} onClose={onClose} label="How to play">
      <div className="howto">
        <div className="howto-head">
          <h2 className="h-serif">How to play</h2>
          <button type="button" className="ibtn boxed" aria-label="Close" onClick={onClose}><Icon name="close" /></button>
        </div>
        <ol className="steps">
          <li>
            <h3>Play six words</h3>
            <p>Any five-letter word, each once. Every letter carries 1 to 5 points: the small number in its corner.</p>
          </li>
          <li>
            <h3>Gold letters raise the multiplier</h3>
            <p>Your multiplier starts at ×1. Each gold letter adds its bonus once per word, however often it appears: the three Ps in PUPPY add +2, not&nbsp;+6.</p>
            <div className="ex"><WordTiles edition={SAMPLE} word="CRAMP" k="typed" size={34} /><span className="eqn"><b>11</b> pts × <b>8</b> = <b>88</b></span></div>
            <div className="ex"><WordTiles edition={SAMPLE} word="PUPPY" k="typed" size={34} /><span className="eqn"><b>14</b> pts × <b>6</b> = <b>84</b></span></div>
          </li>
          <li>
            <h3>Burn tiles take letters away</h3>
            <p>Whatever lands on a <span className="burn-word">burn tile</span> is gone for the rest of the day and drops into your ashes.</p>
            <div className="ex"><WordTiles edition={SAMPLE} word="FLYBY" row={2} size={34} /><span className="eqn">L and B are gone</span></div>
          </li>
          <li>
            <h3>Raise a phoenix</h3>
            <p>After row six, spell one last word using only your ashes. Burned gold still counts.</p>
            <div className="ex"><WordTiles edition={SAMPLE} word="SHAKY" k="ash" size={30} /><span className="eqn">15 × 7 = <b>105</b></span></div>
          </li>
          <li>
            <h3>Make the front page</h3>
            <p>Ranks are set by the best score our solver found for today's puzzle.</p>
            <div className="ex col">
              <Ladder total={850} ranks={SAMPLE_RANKS} width="100%" />
              <div className="ladder-names"><span>Rough Draft</span><span>Headline</span><span>Stop the Presses</span></div>
            </div>
          </li>
        </ol>
        <button type="button" className="btn ink block" onClick={() => { onClose(); onPlay?.() }}>Let's play</button>
      </div>
    </Sheet>
  )
}
